import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import customMedia from '../../../config/themes/variables/breakpoints';

// Fondo del Modal
const StyledModal = styled.div`
  background-color: rgba(25, 25, 25, 0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`;
const StyledModalFull = styled(StyledModal)`
  background-color: ${props => props.theme.colors.light};
  padding-bottom: ${rem('100px')};
`;
// Capa contenedor del modal
const StyledModalContent = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.light};
  box-shadow: 0 ${rem('2px')} ${rem('4px')} 0 rgba(25, 25, 25, 0.41);
  margin: auto auto;
  max-width: ${rem('310px')};
  min-height: ${props => (props.height ? props.height : rem('200px'))};
  min-width: ${rem('260px')};
  overflow: auto;
  padding: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  ${customMedia.greaterThan('medium')`
    max-width: ${rem('375px')};
    min-width: ${rem('320px')};
  `};
  ${customMedia.greaterThan('large')`
    max-width: ${rem('1000px')};
    min-width: ${rem('471px')};
   `};
`;

const StyledModalFullSize = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.light};
  box-shadow: 0 ${rem('2px')} ${rem('4px')} 0 rgba(25, 25, 25, 0.41);
  margin: auto auto;
  min-height: ${rem('200px')};
  min-width: ${rem('260px')};
  overflow: auto;
  padding: 0;
  ${customMedia.greaterThan('medium')`
    max-height:99vh;
    max-width:99vw;
    position: relative;
  `};
`;
// Cabecera y titulo
const StyledModalHeader = styled.header`
  background-color: ${props => props.theme.colors.grayLightest};
  color: ${props => props.theme.colors.main};
  font-family: ${props => props.theme.fonts.bold};
  min-height: ${rem('40px')};
  padding: ${rem('14px')} ${rem('20px')} ${rem('14px')} ${rem('30px')};
  text-transform: uppercase;
`;
// Titulo de la Cabecera
const StyledHeading = styled.h2`
  font-family: ${props => props.theme.fonts.bold};
  font-weight: normal;
  font-size: ${rem('14px')};
  text-transform: uppercase;
  margin: 0;
`;

// Icono de cerrar
const StyledIconClose = styled(Icon)`
  cursor: pointer;
  fill: ${props => props.theme.colors.main};
  float: right;
`;
// Capa para organizar el contenido
const StyledModalBody = styled.div`
  padding: ${rem('15px')};
`;
// Capa para organizar los botones
const StyledModalButton = styled.div`
  padding: ${rem('15px')} ${rem('16px')} ${rem('30px')} 0;
  display: flex;
  justify-content: flex-end;
  position: static;
`;

const StyledModalButtonBetween = styled(StyledModalButton)`
  justify-content: space-between;
  padding: 0;
  margin-right: ${rem('-30px')};
  width: ${rem('230px')};
`;
// Título con icono de Advertencia
const StyledModalTextWarning = styled.h3`
  display: block;
  width: 500px;
  text-align: left;
  line-height: 1.5rem;
  font-size: ${rem('16px')};
  margin: 0;
  color: ${props => props.theme.colors.error};
  font-family: ${props => props.theme.fonts.semiBold};
`;
// Icono de Advertencia en el titulo
const StyledIcon = styled(Icon)`
  float: left;
  position: relative;
  top: ${rem('2px')};
  margin-right: ${rem('10px')};
`;

// Mensaje inferior del modal
const StyledModalBottomMessage = styled.div`
  padding-left: ${rem('30px')};
`;

const StyledModalContentFull = styled.div`
  background-color: ${props => props.theme.colors.light};
  width: 100%;
  min-height: ${rem('830px')};
  max-width: 100%;
  margin: 0;
`;

const StyledModalHeaderFull = styled(StyledModalHeader)`
  margin-top: ${rem('100px')};
  margin-bottom: ${rem('60px')};
  text-align: center;
`;

const StyledHeadingFull = styled(StyledHeading)`
  font-size: ${rem('18px')};
  margin: 0;
`;

const StyledIconCloseFull = styled(StyledIconClose)`
  position: absolute;
  top: ${rem('40px')};
  right: ${rem('40px')};
  width: ${rem('20px')};
  height: ${rem('20px')};
`;

export {
  StyledHeading,
  StyledHeadingFull,
  StyledIcon,
  StyledIconClose,
  StyledIconCloseFull,
  StyledModal,
  StyledModalFull,
  StyledModalBody,
  StyledModalButton,
  StyledModalContent,
  StyledModalContentFull,
  StyledModalHeader,
  StyledModalHeaderFull,
  StyledModalTextWarning,
  StyledModalFullSize,
  StyledModalButtonBetween,
  StyledModalBottomMessage
};
